var $=jQuery;
jQuery(document).ready(function ($) {
  $('.close-notification-bar').click(function (e) { 
    e.preventDefault();
    $('.notification-bar').fadeOut();
  });
  $('li.has-submenu svg.icon.icon-caret').click(function (e) { 
    e.preventDefault();
    $(this).toggleClass('active');
  });
  $('.product__text_box .svg-wrapper').click(function (e) { 
    e.preventDefault();
    $('.product__text_box').slideToggle();
  });
  $('.footer-block.has-dropdown h2.footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  // $('.header-custom-menu li:nth-child(2)').click(function (e) { 
  //     e.preventDefault();
  //     $('.header-custom-menu li').removeClass('active');
  //     $(this).addClass('active');
  //     $('.header__inline-menu').addClass('show-menu-second');
  // });
  // $('.header-custom-menu li:nth-child(1)').click(function (e) { 
  //     e.preventDefault();
  //     $('.header-custom-menu li').removeClass('active');
  //     $(this).addClass('active');
  //     $('.header__inline-menu').removeClass('show-menu-second');
  // });
  // if ($(".header-custom-menu li:eq(1)").hasClass("active")) {
  //     $(".header__inline-menu").addClass("show-menu-second");
  // }
  
    let $menu1 = $("#Details-HeaderMenu-1");
    let $menu2 = $("#Details-HeaderMenu-2");
    let $defaultMenu = $menu1; 

    if ($("body").hasClass("page-industrie") || $("body").hasClass("page-industrie-collection")) {
      $defaultMenu = $menu2;
  }

    let $activeMenu = [$menu1, $menu2].find($menu => $menu.find("> .header__active-menu-item").length);

    if ($activeMenu) {
        $activeMenu.attr("open", "");
    } else {
        $defaultMenu.attr("open", "");
    }

    // $("#Details-HeaderMenu-1 > summary, #Details-HeaderMenu-2 > summary").on("click", function (event) {
    //     let $clickedMenu = $(this).closest("details");
    //     let $otherMenu = ($clickedMenu.is($menu1)) ? $menu2 : $menu1;

    //     if (!$clickedMenu.attr("open")) {
    //         $otherMenu.removeAttr("open");
    //         $clickedMenu.attr("open", "");
    //     }
    //     event.preventDefault();
    // });
  
    // $('.sub-details > summary').on('click', function (e) {
    //     e.preventDefault();
    //     let parent = $(this).parent('.sub-details');

    //     if (parent.attr('open')) {
    //         parent.removeAttr('open'); 
    //     } else {
    //         $('.sub-details').removeAttr('open'); 
    //         parent.attr('open', ''); 
    //     }
    // });
  $('.sub-details > summary').on('click', function (e) {
    if (!$(e.target).is('svg') && !$(e.target).is('path')) {
        return;
    }

    e.preventDefault();
    let parent = $(this).parent('.sub-details');

    if (parent.attr('open')) {
        parent.removeAttr('open');
    } else {
        $('.sub-details').removeAttr('open');
        parent.attr('open', '');
    }
});


  //menu mobile
  $('.menu-drawer .menu-drawer__menu-item.parent-link').on('click', function () {
    $('.menu-drawer .menu-drawer__menu-item.parent-link').removeClass('active');
    $(this).addClass('active');
  });
});

$(document).ready(function(){
  ///// Tab Faq
  $(document).on('click','.acctab_title', function(e){
     if($(window).width() >= 768){
        $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }else{
       $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }
  });
  $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
      $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });
  ///// Tab Faq
});
 document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('[data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                    
                    productGrid.innerHTML += newProducts;
                    
                    var sliderProducts = document.querySelectorAll('.has-slider-wrapper');

                    sliderProducts.forEach(function(slider) {
                        new Flickity(slider, {
                            pageDots: false,
                            freeScroll: false,
                            wrapAround: true,
                            prevNextButtons: true,
                            autoPlay: false,
                            groupCells: false,
                            cellAlign: 'center',
                        });
                    });
                    
                    const newButton = tempDiv.querySelector('[data-pagination-btn]');
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "MEHR ANZEIGEN";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Keine Produkte mehr";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
});
//slider mobile
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.slider-mobile', {
      slidesPerView: 2,
      spaceBetween: 20,
      cssMode: true,
      loop: true,
      centeredSlides: false,
      autoplay: {
        delay: 150000, 
        disableOnInteraction: false, 
      },
      pagination: {
        el: ".slider-mobile .swiper-pagination",
        clickable: true,
      },
    });
});



